import React, { useEffect, useState } from 'react';
import Tabs from 'studio/components/Tabs/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import withStyles from '@mui/styles/withStyles';
import styles from './Configuration.styles';
import Content from 'studio/components/Content/Content';
import Progress from 'studio/components/Progress';
import EditKnowledgeGraph from 'studio/pages/EditKnowledgeGraph';
import DatabaseConnection from 'studio/pages/DatabaseConnection';
import LinearProgress from '@mui/material/LinearProgress';
import BuildIcon from '@mui/icons-material/BuildRounded';
import AssignmentIcon from '@mui/icons-material/AssignmentRounded';
import { trackEvent } from 'utils/eventTracking';
import AccessControl from 'studio/pages/AccessControl/AccessControl';
import SecurityIcon from '@mui/icons-material/Security';
import { KgPermissions } from 'studio/constants';
import { DatabaseIcon } from 'components/Icons';
import PageTitle from 'studio/components/PageTitle';

const Configuration = ({ classes, languages, knowledgeGraph, orgSettings, fetchKnowledgeGraphs, user }) => {
  useEffect(() => {
    trackEvent('Studio Configuration Opened');
  }, []);

  const [index, setIndex] = useState(0);

  const showDatabaseConnection = !!knowledgeGraph && !knowledgeGraph.data.isDatabaseManagedByVeezoo;
  const showAccessControl = showDatabaseConnection;
  const hasUpdateAccessControlPermission = knowledgeGraph.data.kgPermissions.includes(
    KgPermissions.UpdateAccessControl
  );

  return (
    <Content loading={!languages} data-test="configurationContent">
      <PageTitle icon={BuildIcon}>Configuration</PageTitle>
      <Tabs value={index} onChange={(_, index) => setIndex(index)}>
        <Tab
          label={
            <div>
              <AssignmentIcon />
              General Information
            </div>
          }
        />
        {showDatabaseConnection && (
          <Tab
            label={
              <div>
                <DatabaseIcon />
                Database Connection
              </div>
            }
          />
        )}
        {showAccessControl && hasUpdateAccessControlPermission && (
          <Tab
            label={
              <div>
                <SecurityIcon />
                Access Control
              </div>
            }
          />
        )}
      </Tabs>
      <div hidden={index !== 0}>
        <Typography variant="h2" className={classes.generalTitle}>
          <AssignmentIcon />
          General Information
        </Typography>
        {!knowledgeGraph ? (
          <Progress />
        ) : knowledgeGraph.data.isDataReady === false ? (
          <div className={classes.information}>
            <div className={classes.linearProgress}>
              <LinearProgress />
            </div>
            <p>We are preparing your data, it is not ready yet.</p>
            <p>Once the data is ready, we will inform you by e-mail.</p>
            <p>Note: This can take up to a few hours.</p>
          </div>
        ) : knowledgeGraph.data.isBeingPrepared ? (
          <div className={classes.information}>
            <div className={classes.linearProgress}>
              <LinearProgress data-test="knowledgeGraphIsBeingPreparedProgress" />
            </div>
            <p>The KG is in preparation, please wait shortly.</p>
          </div>
        ) : (
          <EditKnowledgeGraph
            languages={languages}
            knowledgeGraph={knowledgeGraph}
            orgSettings={orgSettings}
            key={knowledgeGraph && knowledgeGraph.data.id}
            fetchKnowledgeGraphs={fetchKnowledgeGraphs}
            user={user}
          />
        )}
      </div>
      {showDatabaseConnection && (
        <div hidden={index !== 1}>
          {!knowledgeGraph ? (
            <Progress />
          ) : (
            <DatabaseConnection
              languages={languages}
              knowledgeGraph={knowledgeGraph}
              key={knowledgeGraph && knowledgeGraph.data.id}
            />
          )}
        </div>
      )}
      {showAccessControl && hasUpdateAccessControlPermission && (
        <div hidden={index !== 2}>
          <AccessControl knowledgeGraph={knowledgeGraph} user={user} />
        </div>
      )}
    </Content>
  );
};

export default withStyles(styles)(Configuration);
